module.exports = __webpack_public_path__ + "static/media/informationandcommunicationtechnologyservices.66b141b0.jpeg";